import { Portal } from '@lt/components';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import Close from '@lt/components/icons-react/Close';
import { useTranslation } from '@lt/localization';
import { api } from 'src/api';
import styles from './vpnBanner.module.css';

interface VpnBannerProps {
  isMobile: boolean;
}

export const VpnBanner: FC<VpnBannerProps> = ({ isMobile }) => {
  const [isShow, setIsShow] = useState(false);
  const [isAnimationGoing, setIsAnimationGoing] = useState(false);
  const { t } = useTranslation();

  const checkIsVPN = async () => {
    try {
      const { show_vpn } = await api.getBannerShowVpn();
      setIsShow(show_vpn);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      checkIsVPN();
    }, 4000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  const closeHandler = () => {
    const timeoutId = setTimeout(() => {
      setIsShow(false);
      clearTimeout(timeoutId);
    }, 250);

    setIsAnimationGoing(true);
  };

  if (!isShow) {
    return null;
  }

  return (
    <Portal>
      <div
        className={classNames(styles.container, {
          [styles.containerMobile]: isMobile,
          [styles.containerDesktop]: !isMobile,
          [styles.containerClose]: isAnimationGoing,
        })}
      >
        <div className={styles.content}>
          <div className={styles.title}>
            {isMobile
              ? t('vpnBanner.mobile.title')
              : t('vpnBanner.desktop.title')}
          </div>
          <div className={styles.text}>
            {isMobile
              ? t('vpnBanner.mobile.text')
              : t('vpnBanner.desktop.text')}
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={closeHandler}
          >
            <Close />
          </button>
        </div>
      </div>
    </Portal>
  );
};
